import type { MouseEvent } from 'react';

const PRIMARY_BUTTON = 0;

const MIDDLE_BUTTON = 1;

export const isPlainLeftClick = (event: MouseEvent<Element>): boolean =>
  event.button === PRIMARY_BUTTON && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

export const isNewTabClick = (event: MouseEvent<Element>): boolean =>
  event.button === MIDDLE_BUTTON || (event.button === PRIMARY_BUTTON && (event.metaKey || event.ctrlKey));
